export default __webpack_public_path__ + "static/Celebration-ad60914391b2e2d06f8b77881fe435d89c71b068b880d1cdd5a4896069c677be.png";